import React from 'react';
import TextField from '@material-ui/core/TextField';
import withSetting from './SettingsHOC';

function ConfigurationInput(props) {
  const handleTextChange = ({ target }) => {
    props.onChange(target.value);
  };

  return (
    <TextField
      inputProps={{ style: { fontSize: 15 } }}
      variant='outlined'
      onChange={handleTextChange}
      value={props.value || ''}
    />
  );
}

export default withSetting(ConfigurationInput);
